'use strict';

// TODO @andre --- remove

var _ = require('lodash');

function MapUtil () {

  var config = null;

  this.init = function (config_) {
    config = config_;
  };

  /**
   * Get the configurations for a tile layer. The returned object is ready to be passed into
   * angular-leaflet for rendering.
   * 
   * @param  {String} type Tile type
   * @param  {String} id Layer id
   * @param  {Object} options Layer options
   * @return {Object} Tile layer object
   */
  this.getTileLayer = function (type, id, options) {

    if (!config) {
      throw new Error('MapUtil not initialized');
    }

    if (!config.tileLayers) {
      throw new Error('No "tileLayers" are defined');
    }

    var layer = _.clone(config.tileLayers[type], true);

    layer.name = id || layer.name;
    layer.layerOptions = layer.layerOptions || {};

    if (options) {
      _.extend(layer.layerOptions, options);
    }

    layer.$show = function (show) {
      show = show !== undefined ? show : true;
      this.visible = show;
    };

    return layer;
  };
}

module.exports = MapUtil;


// WEBPACK FOOTER //
// ./src/common/utils/MapConfigUtil.js